import { ErrorPage } from "./ErrorPage";

export function Forbidden() {
  return (
    <ErrorPage title="Permission denied" text="You do not have permission to access this page." />
  );
}
